import { motion } from "framer-motion";
import { brandColors as colors, usePalette } from "@/lib/palette";
import { fonts } from "@/lib/fonts";
import { stagger } from "@/lib/animations";
import type { GuideCard as GuideCardType } from "@/lib/guides";
import GuideCard from "./GuideCard";

type Props = {
  related: GuideCardType[];
  topicName?: string;
};

export default function RelatedGuides({ related, topicName }: Props) {
  const theme = usePalette();
  if (!related.length) return null;

  return (
    <section className="py-20" style={{ backgroundColor: theme.sectionBg }}>
      <div className="mx-auto max-w-6xl px-6">
        <p
          className="mb-2 text-xs uppercase"
          style={{
            fontFamily: fonts.body,
            fontWeight: 800,
            letterSpacing: "0.2em",
            color: theme.accent,
          }}
        >
          Keep going
        </p>
        <h2
          className="mb-10 text-3xl lg:text-4xl"
          style={{ fontFamily: fonts.logo, color: colors.navy, fontWeight: 400 }}
        >
          More{" "}
          <span style={{ fontFamily: fonts.heading, color: theme.warm }}>
            {topicName ? topicName.toLowerCase() : "guides"}
          </span>{" "}
          favourites
        </h2>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
          variants={stagger}
          className="grid gap-6 md:grid-cols-3"
        >
          {related.map((g, i) => (
            <GuideCard key={g.id} guide={g} index={i} showTopic={false} />
          ))}
        </motion.div>
      </div>
    </section>
  );
}
